import {
  AfterViewInit,
  Directive,
  forwardRef,
  Inject,
  Injectable,
  Injector,
  OnDestroy,
  Optional,
  SkipSelf
} from "@angular/core";
import {
  DISPLAY_TYPE,
  StylableComponent,
  IWidgetConfig,
  provideAsWidgetRef,
  Parent, register
} from '@wm/components-base';
import { EventNotifier, runtimeEventManager } from '@wm/core';

const DEFAULT_CLS = 'app-page container';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-page',
  hostClass: DEFAULT_CLS
}

@Directive({
  selector: '[wmPage]',
  exportAs: 'wmPage',
  providers: [
    provideAsWidgetRef(PageDirective)
  ],
  standalone: true
})
export class PageDirective extends StylableComponent {
  static initializeProps = register('wm-page');

  private _eventNotifier = new EventNotifier(false);
  eventManagerService: any;
  pageWsService: any;

  constructor(inj: Injector, @SkipSelf() @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    this.eventManagerService = runtimeEventManager.getService('eventManagerService');
    this.pageWsService = runtimeEventManager.getService('pageWSService');

    // re arrange page elements on nav height change
    runtimeEventManager.on('nav-height-change').subscribe((height: string) => {
      let pageEl = this.$element;
      let contentEl = this.$element.find('.app-content-row');
      let navEl = this.$element.find('[wmleftpanel]');
      let headerEl = this.$element.find('[wmheader]');
      let topNavEl = this.$element.find('[wmtopnav]');
      let footerEl = this.$element.find('[wmfooter]');
      if(height === 'full') {
        navEl && pageEl.prepend(navEl);
        headerEl && pageEl.remove(headerEl);
        topNavEl && pageEl.remove(topNavEl);
        footerEl && pageEl.remove(footerEl);
        navEl && contentEl.remove(navEl);
        topNavEl && contentEl.prepend(topNavEl);
        headerEl && contentEl.prepend(headerEl);
        footerEl && contentEl.append(footerEl);
        pageEl.addClass('app-nav-' + height);
      } else {
        headerEl && contentEl.remove(headerEl);
        topNavEl &&contentEl.remove(topNavEl);
        footerEl && contentEl.remove(footerEl);
        navEl && contentEl.prepend(navEl);
        navEl && pageEl.remove(navEl);
        topNavEl && pageEl.prepend(topNavEl);
        headerEl && pageEl.prepend(headerEl);
        footerEl && pageEl.append(footerEl);
        pageEl.removeClass('app-nav-' + 'full');
      }
    })
  }

  /**
   * A child component can notify page using this method. Notified event will be passed to
   * subscribed children only after page initialization.
   *
   * @param {string} eventName
   * @param data
   */
  public notify(eventName: string, ...data: Array<any>) {
    // @ts-ignore
    this._eventNotifier.notify.apply(this._eventNotifier, arguments);
  }

  /**
   * The main purpose of this function is to provide communication between page children objects.
   * Child component can subscribe for an event that will be emitted by another child component.
   *
   * @param eventName
   * @param {(data: any) => void} callback
   * @returns {any}
   */
  public subscribe(eventName: string, callback: (data: any) => void): () => void {
    return this._eventNotifier.subscribe(eventName, callback);
  }
}
